import { render, staticRenderFns } from "./Auftraege_Abgelehnt.vue?vue&type=template&id=747a12a6&scoped=true"
import script from "./Auftraege_Abgelehnt.vue?vue&type=script&lang=js"
export * from "./Auftraege_Abgelehnt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../home/zarzar/Documents/public-solution/bis-office/web/auftragsbuch/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "747a12a6",
  null
  
)

export default component.exports